/**
 * Carries the id of the currently-selected cluster region so the region box
 * can render an "active" ring. Kept separate from HighlightContext (which
 * carries the node/edge highlight set) and provided the same way — read from
 * context rather than baked into node data, so selection never triggers a
 * layout rebuild.
 */

import { createContext } from 'react';

export const SelectedClusterContext = createContext<string | null>(null);
